import React, { FC } from 'react'
import { getUserBackgroundColor, getInitials } from '../user-avatar/helpers'
import { getTextClassForColor } from '../../../../../../shared/colorUtils'
import { Tooltip } from 'front-end/src/components'

export const UserIcon: FC<{
  user:
    | {
        display_name?: string | undefined | null
        image_url?: string | undefined | null
      }
    | undefined
    | null
  size?: number
  showTooltip?: boolean
  iconOverlay?: any
}> = ({ user, size = 36, showTooltip, iconOverlay, children }) => {
  if (!user) {
    return null
  }
  const image = user.image_url

  const iconStyle = {
    width: size,
    height: size,
    lineHeight: `${size}px`,
    fontSize: size / 2 - 3.6,
    textShadow: 'none',
    backgroundImage: undefined,
    backgroundColor: undefined,
    color: undefined
  }
  let textClassName = ''
  if (image) {
    // @ts-expect-error 9/11/2020
    iconStyle.backgroundImage = `url(${image})`
    // @ts-expect-error 9/11/2020
    iconStyle.color = 'transparent'
  } else {
    // @ts-expect-error 9/11/2020
    iconStyle.backgroundColor = getUserBackgroundColor(user)
    textClassName = getTextClassForColor(iconStyle.backgroundColor)
  }
  return (
    <div className="user-icon-wrapper">
      <Tooltip
        disabled={!showTooltip}
        contentClassName="user-icon-label"
        text={user.display_name}
      >
        {iconOverlay}
        {children}
        <div className={`user-icon ${textClassName}`} style={iconStyle}>
          {getInitials(user)}
        </div>
      </Tooltip>
    </div>
  )
}

export default UserIcon
